<template>
  <v-container class="cmp-booking-promoters-sidewindow dt-sidewindow">
    <div class="dt-tabs-container">
      <PromoterDetails></PromoterDetails>
      <glayout
        :tabs="sideWindowTabs"
        :loading="selectedPromoterData && selectedPromoterData.loading"
      >
        <gtab>
          <grow>
            <gcol>
              <gbox :title="$t('contact')" h="326">
                <Contact :promoter-overview="selectedPromoterData" @changed="onPromoterContactChanged" />
              </gbox>
              <gbox
                :h="
                  boxHeightNamed({
                    rowCount:
                    selectedPromoterData &&
                    selectedPromoterData.contact_relations &&
                    selectedPromoterData.contact_relations.length,
                    offset: NTOffsets.WithHeader,
                    min: 1
                  })
                "
                :title="$t('related_contacts')"
              >
                <RelatedContacts :promoter-overview="selectedPromoterData" @deleted="onPromoterRelatedContactDeleted" />
              </gbox>
            </gcol>
            <gcol>
              <gbox :title="$t('communication_info')" h="263">
                <Communication :promoter-overview="selectedPromoterData" @changed="onPromoterContactChanged" />
              </gbox>
              <gbox
                :h="
                  boxHeight(
                    selectedPromoterData &&
                    selectedPromoterData.files && selectedPromoterData.files.length,
                    NTOffsets.WithDBoxBottom
                  )
                "
                :title="$t('related_documents')"
              >
                <DBoxFiles
                  :files="selectedPromoterData.files"
                  :externalId="
                    selectedPromoterData &&
                    selectedPromoterData.file_relation_external_id
                  "
                  :externalTable="'contacts'"
                />
              </gbox>
            </gcol>
          </grow>
        </gtab>
        <gtab id="additional_info">
          <grow>
            <gcol>
              <gbox :title="$t('notes')" bc="var(--bc-note)">
                <DBoxTextarea
                  :value="selectedPromoterData.contact && selectedPromoterData.contact.notes"
                  :id="'notes'"
                  @blur="onNotesBlur"
                />
              </gbox>
            </gcol>
            <gcol>
              <gbox
                :h="boxHeight(selectedPromoterData && selectedPromoterData.fields && selectedPromoterData.fields.length, 2)"
                :title="$t('custom_field')"
              >
                <PromoterCustomFields
                  :custom-fields="selectedPromoterData.fields"
                  @changed="onChangePromoterCustomField"
                />
              </gbox>
            </gcol>
          </grow>
        </gtab>
        <gtab id="bookings">
          <grow>
            <gcol>
              <gbox
                :h="
                  boxHeightNamed({
                    rowCount:
                      selectedPromoterData &&
                      selectedPromoterData.bookings &&
                      selectedPromoterData.bookings.length,
                    offset: NTOffsets.WithHeader,
                    min: 1
                  })
                "
                :title="$t('bookings')"
              >
                <RelatedBookings :selectedPromoterData="selectedPromoterData" />
              </gbox>
            </gcol>
          </grow>
        </gtab>
      </glayout>
    </div>
  </v-container>
</template>

<script>
import { BookingStoreNamespace as storeNS } from "../../../store";
import { mapActions, mapGetters, mapMutations } from "vuex";
import * as ActionTypes from "../../../store/types";

import PromoterDetails from "./promoter-details";

import Overview from "./overview/overview";
// import MoneyDetails from './money-details/money-details';
// import Documents from './documents/documents';
// import EventDetails from './event-details/event-details';
import { getGITranslate } from "../../../../../plugins/box-widget/models/grid-item.model";
import DBoxTextarea from "../../../../../dt-plugins/dbox-textarea/dbox-textarea";
import { scrollToWithAnimation } from "../../../../../plugins/scroller/scrollTo";
import {
  bookingPromoterDetailsRoute,
  bookingPromoterDetailsTabRoute
} from "../../../router/router";
import { checkTabListPermission } from "../../../../../router/guard";

import { bookingPromotersService as BPS } from "../../../services/booking-promoters.service";
import Contact from "./contact";
import Communication from "./communication";
import RelatedContacts from "./related-contacts";
import PublicComments from "./public-comments";
import RelatedBookings from "./related-bookings";
import PromoterCustomFields from "./custom-fields";
import DBoxFiles from "../../../../../dt-plugins/dbox-files/dbox-files";
import { createHttpHeaderOptions } from "../../../../b2b/services/http-client";
import { HttpClient } from "../../../../../services/http/http-client";
import { createDTGridHost } from "../../../../../dt-plugins/dt-grid/dt-grid.mixin";

const moduleRoute = "booking";
const submenuRoute = "promoters";

export default {
  mixins: [createDTGridHost()],
  components: {
    RelatedContacts,
    Contact,
    Communication,
    DBoxTextarea,
    PublicComments,
    PromoterCustomFields,
    RelatedBookings,

    DBoxFiles,

    PromoterDetails,
    Overview
    // MoneyDetails,
    // Documents,
    // EventDetails
  },
  data: function() {
    return {
      active: -1,
      // promoterOverviewNotes: "",
      // promoterAdditionalInfoFiles: [],
      // promoterAdditionalInfoFields: []
    };
  },
  mounted: function() {
    // this.routeMount();
  },
  watch: {
    // bookingPromoterSideWindowSelectedTab: function(to, from) {
    //   const selectedTab = this.sideWindowTabs.find(e => e.route === to);
    //   this.routeToTab(selectedTab);
    //   this.scrollToTab(selectedTab);
    // },
    // promoterOverview: function(to, from) {
    //   this.promoterOverviewNotes = to.contact.notes;
    // },
    // promoterAdditionalInfo: function(to, from) {
    //   this.promoterAdditionalInfoFiles = to.files;
    //   this.promoterAdditionalInfoFields = to.fields;
    //   console.log("promoterAdditionalInfo: ", to.fields);
    // }
  },
  computed: {
    ...mapGetters(storeNS, {
      // bookingSidewindowTabs: "bookingSidewindowTabs",
      bookingPromoterSideWindowSelectedTab:
        "bookingPromoterSideWindowSelectedTab",
      promoterOverview: "bookingPromoterSelectedOverView",
      promoterBookings: "bookingPromoterSelectedBookings",
      promoterAdditionalInfo: "bookingPromoterSelectedAdditionalInfo",
      isSelectedPromoterLoading: "isSelectedPromoterLoading",
      promoterDetails: "promoterDetails"
    }),
    promoter_id: function() {
      return this.$route.params.promoter_id;
    },
    selectedPromoterData: function() {
      const selectedPromoterDetails =  (this.promoterDetails || [])[this.promoter_id] || {};
      return {...selectedPromoterDetails};
    },
    // activeTabIndex: {
    //   get: function() {
    //     if (this.$route && this.$route.params.tab) {
    //       const tabRoute = this.$route.params.tab;
    //       const activeTab = this.sideWindowTabs.findIndex(
    //         e => e.route == tabRoute
    //       );
    //       if (activeTab) {
    //         return `${activeTab}`;
    //       } else {
    //         return `${0}`;
    //       }
    //     } else {
    //       return `${0}`;
    //     }
    //   },
    //   set: function(value) {}
    // },
    sideWindowTabs: function() {
      return checkTabListPermission(moduleRoute, submenuRoute, [
        { route: "overview", value: this.$t("tab_title_overview") },
        {
          route: "additional_info",
          value: this.$t("tab_title_additional_info")
          // VGI_ID: "promoter_tab_additional_info_section"
        },
        {
          route: "bookings",
          value: this.$t("tab_title_bookings")
          // VGI_ID: "promoter_tab_booking_section"
        }
      ]);
    }
  },
  methods: {
    ...mapMutations(storeNS, {
      [ActionTypes.SET_BOOKING_PROMOTER_SELECTED_TAB]:
        ActionTypes.SET_BOOKING_PROMOTER_SELECTED_TAB,
      [ActionTypes.SET_BOOKING_PROMOTER_TAB_OVERVIEW]:
        ActionTypes.SET_BOOKING_PROMOTER_TAB_OVERVIEW
    }),
    ...mapActions(storeNS, {
      // [ActionTypes.CLOSE_BOOKING_DETAILS]: ActionTypes.CLOSE_BOOKING_DETAILS,
      [ActionTypes.ARTIST_FILES.DELETE.SINGLE]:
        ActionTypes.ARTIST_FILES.DELETE.SINGLE,
      [ActionTypes.PromoterContact.UPDATE.SINGLE]:
        ActionTypes.PromoterContact.UPDATE.SINGLE,
      [ActionTypes.PromoterRelatedContacts.DELETE.SINGLE]:
        ActionTypes.PromoterRelatedContacts.DELETE.SINGLE,
      [ActionTypes.PromoterCustomFields.UPDATE.SINGLE]:
        ActionTypes.PromoterCustomFields.UPDATE.SINGLE
    }),
    onNotesBlur: function(event) {
      // BPS.modify_contacts(
      //   this.promoterOverview.contact["contact_id"],
      //   "notes",
      //   event.target.value
      // );
      this[ActionTypes.PromoterContact.UPDATE.SINGLE]({ 
        name: "notes", 
        value: event.target.value, 
        contactID: this.selectedPromoterData.contact["contact_id"], 
        promoter_id: this.promoter_id
      });
    },
    // routeMount: function() {
    //   // console.log(this.$route.name);
    //   if (this.$route.name === bookingPromoterDetailsTabRoute) {
    //     const selectedTab = this.sideWindowTabs.find(
    //       e => e.route === this.$route.params["tab"]
    //     );

    //     setTimeout(() => {
    //       this.scrollToTab(selectedTab);
    //     }, 3000);
    //   }
    // },
    /*onBoxPinned: function({ element, title }) {
      this.$store.commit(`${storeNS}/${ActionTypes.PIN_BOX}`, {
        layoutName,
        title,
        element
      });
    },
    selectBox: function(title) {
      this.$store.commit(`${storeNS}/${ActionTypes.SELECT_BOX}`, {
        layoutName,
        title
      });
    },
    onMinimize: function(title) {
      this.$store.commit(`${storeNS}/${ActionTypes.MINIMIZE_BOX}`, {
        layoutName,
        title
      });
      this.$refs.gridLayoutRefPromoterDetails.resizeEvent("resizeend");
    },
    onMaximize: function(title) {
      this.$store.commit(`${storeNS}/${ActionTypes.MAXIMIZE_BOX}`, {
        layoutName,
        title
      });
      this.$refs.gridLayoutRefPromoterDetails.resizeEvent("resizeend");
    },
    onBoxPinned: function({ element, title }) {
      this.$store.commit(`${storeNS}/${ActionTypes.PIN_BOX}`, {
        layoutName,
        title,
        element
      });
    },*/
    // tabSelected: function(e) {
    //   this[ActionTypes.SET_BOOKING_PROMOTER_SELECTED_TAB](
    //     this.sideWindowTabs[e].route
    //   );
    // },
    // scrollToTab: function(selectedTab) {
    //   // const gridItem = this.gridLayout.layout.find(
    //   //   e => e.id === `VGI_${selectedTab.VGI_ID}`
    //   // );

    //   // if (!gridItem) {
    //   //   return;
    //   // }

    //   // const sectionElement = document.getElementById(gridItem.id);

    //   const transformValue = getGITranslate(sectionElement.style.transform);

    //   scrollToWithAnimation(
    //     this.$refs.gridPage,
    //     selectedTab.route === "overview"
    //       ? transformValue.y
    //       : transformValue.y + 50,
    //     200
    //   );
    // },
    closePromoterDetails: function(e) {
      this.$emit("cancelled");
    },
    // routeToTab: function(tab) {
    //   this.$router.push({
    //     name: bookingPromoterDetailsTabRoute,
    //     params: {
    //       promoter_id: this.$router.currentRoute.params.promoter_id,
    //       tab: tab.route
    //     },
    //     query: {
    //       ...this.$route.query
    //     }
    //   });
    // },
    // setBookingPromoterSelectedChanges(tab, changedSelectedTabData) {
    //   // console.log("mdsir: ", tab, changedSelectedTabData);
    //   switch (tab) {
    //     case "overview":
    //       this[ActionTypes.SET_BOOKING_PROMOTER_TAB_OVERVIEW](
    //         changedSelectedTabData
    //       );
    //       break;
    //     case "bookings":
    //       break;
    //     case "additional_info":
    //       break;
    //   }
    //   // console.log("set changes after commit: ", tab, this.promoterOverview);
    // },
    onChangePromoterCustomField({ custom_data_id, value }) {
      // HttpClient.modify(
      //   "custom_data_id",
      //   custom_data_id,
      //   "data",
      //   value,
      //   "custom_data"
      // );
      this[ActionTypes.PromoterCustomFields.UPDATE.SINGLE]({ custom_data_id, value, promoter_id: this.promoter_id });
    },
    onPromoterContactChanged(payload) {
      this[ActionTypes.PromoterContact.UPDATE.SINGLE]({ ...payload, promoter_id: this.promoter_id });
    },
    onPromoterRelatedContactDeleted(item) {
      this[ActionTypes.PromoterRelatedContacts.DELETE.SINGLE]({ item, promoter_id: this.promoter_id });
    }
  }
};
</script>

<style lang="scss">
.cmp-booking-promoters-sidewindow {
  .dt-grid-layout {
    height: calc(100vh - 123px);
  }

  .overview-options {
    margin-top: 7%;
    .icons {
      display: flex;
      justify-content: center;
      img:first-child {
        padding-top: 2px;
      }
      img {
        cursor: pointer;
      }
      .loading-icon-container {
        width: 30px;
        .loading-icon {
          width: 15px;
          height: 15px;
          padding-left: 5px;
        }
      }

      .status {
        margin-top: 17px;
        margin-left: 5px;
        .circle {
          width: 15px;
          height: 15px;
          border-radius: 30px;
        }
      }
    }
  }
}
</style>
